import { CapoPlugin } from "/var/www/mj_client/releases/20251106060921/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];